import { parseUrl } from '@wix/native-components-infra';
const getCurrentUrlWithoutParams = wixCodeApi => {
  const url = wixCodeApi.location.url;
  const parsedUrl = parseUrl(url);
  return `${parsedUrl.protocol}://${parsedUrl.host}${parsedUrl.path}`;
};
export async function getServiceSlug(_ref) {
  var _wixCodeApi$site$curr, _wixCodeApi$site$curr2, _wixCodeApi$site$curr3;
  let {
    wixCodeApi,
    pageName,
    useCustomUrlSegments
  } = _ref;
  if (useCustomUrlSegments) {
    var _urlSegments$segments;
    const url = getCurrentUrlWithoutParams(wixCodeApi);
    const urlSegments = await (wixCodeApi.site.getCustomizedUrlSegments == null ? void 0 : wixCodeApi.site.getCustomizedUrlSegments(url));
    const possibleSlugFromSegments = urlSegments == null || (_urlSegments$segments = urlSegments.segments) == null ? void 0 : _urlSegments$segments.slug;
    if (possibleSlugFromSegments) {
      return possibleSlugFromSegments;
    }
  }
  let sitePageName = (_wixCodeApi$site$curr = wixCodeApi.site.currentPage) == null || (_wixCodeApi$site$curr = _wixCodeApi$site$curr.url) == null ? void 0 : _wixCodeApi$site$curr.substring(1).toLowerCase();
  const locationPaths = wixCodeApi.location.path.map(subPath => subPath.toLowerCase());
  if (!sitePageName && wixCodeApi.window.viewMode.toLowerCase() === 'site' && ((_wixCodeApi$site$curr2 = wixCodeApi.site.currentPage) == null ? void 0 : _wixCodeApi$site$curr2.type) === 'lightbox') {
    sitePageName = locationPaths[0];
  }
  let sitePageNameIndex = locationPaths.indexOf(sitePageName);
  const isSitePageNameExistInPath = sitePageNameIndex !== -1;
  if (!isSitePageNameExistInPath && wixCodeApi.window.viewMode.toLowerCase() === 'preview') {
    sitePageNameIndex = 1;
  }
  const isServiceSlugExistsInPath = isSitePageNameExistInPath && sitePageNameIndex !== wixCodeApi.location.path.length - 1;
  let serviceSlug = isServiceSlugExistsInPath ? wixCodeApi.location.path[sitePageNameIndex + 1] : '';
  const shouldFixProblematicSiteStructureInPreview = wixCodeApi.window.viewMode.toLowerCase() === 'preview' && !isSitePageNameExistInPath && wixCodeApi.location.path.length === 1 && locationPaths[0] !== pageName;
  const siteWithRouterPage = (_wixCodeApi$site$curr3 = wixCodeApi.site.currentPage) == null ? void 0 : _wixCodeApi$site$curr3.prefix;
  if (shouldFixProblematicSiteStructureInPreview || siteWithRouterPage) {
    serviceSlug = wixCodeApi.location.path[0];
  }
  if (serviceSlug) {
    serviceSlug = decodeURI(serviceSlug);
  }
  return serviceSlug;
}
//# sourceMappingURL=getServiceSlug.js.map